import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDragScroll]',
  standalone: true
})
export class DragScrollDirective {
  private isMouseDown = false;
  private isDragging = false;
  private startX = 0;
  private startY = 0;
  private scrollLeft = 0;
  private scrollTop = 0;
  private dragThreshold = 3;
  private mouseDownTime = 0;

  constructor(private el: ElementRef) {
    this.el.nativeElement.style.cursor = 'grab';
    this.el.nativeElement.style.userSelect = 'none';
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    event.preventDefault();
    this.isMouseDown = true;
    this.isDragging = false;
    this.mouseDownTime = Date.now();
    this.startX = event.pageX - this.el.nativeElement.offsetLeft;
    this.startY = event.pageY - this.el.nativeElement.offsetTop;
    this.scrollLeft = this.el.nativeElement.scrollLeft;
    this.scrollTop = this.el.nativeElement.scrollTop;
    this.el.nativeElement.style.cursor = 'grabbing';
    document.body.style.userSelect = 'none';
  }

  @HostListener('mouseleave')
  @HostListener('mouseup', ['$event'])
  onMouseUp(event?: MouseEvent): void {
    if (event && this.isDragging) {
      event.preventDefault();
      event.stopPropagation();

      // Prevent the subsequent click event
      const clickPreventer = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        document.removeEventListener('click', clickPreventer, true);
      };
      document.addEventListener('click', clickPreventer, true);
    }

    this.isMouseDown = false;
    this.isDragging = false;
    this.el.nativeElement.style.cursor = 'grab';
    document.body.style.userSelect = '';
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (!this.isMouseDown) return;

    const x = event.pageX - this.el.nativeElement.offsetLeft;
    const y = event.pageY - this.el.nativeElement.offsetTop;
    const moveX = Math.abs(x - this.startX);
    const moveY = Math.abs(y - this.startY);

    if (moveX > this.dragThreshold || moveY > this.dragThreshold) {
      this.isDragging = true;
    }

    if (this.isDragging) {
      event.preventDefault();
      event.stopPropagation();
      const walkX = (x - this.startX);
      const walkY = (y - this.startY);
      this.el.nativeElement.scrollLeft = this.scrollLeft - walkX;
      this.el.nativeElement.scrollTop = this.scrollTop - walkY;
    }
  }

  @HostListener('dragstart', ['$event'])
  onDragStart(event: Event): void {
    event.preventDefault();
  }

  @HostListener('selectstart', ['$event'])
  onSelectStart(event: Event): void {
    event.preventDefault();
  }
}
